// @flow
import getEndpointUrl from 'api/getEndpointUrl';
import checkResponse from 'api/checkIfResponseIsOK';
import wrapWithNetworkError from 'api/wrapWithNetworkError';

export const postObservations = wrapWithNetworkError(function postObservation(
  token: string,
  props: { ugcId: Id, body: Object, clientId: Id }
) {
  const { ugcId, body, clientId = 1 } = props;
  const fetchUrl = getEndpointUrl(
    `/moderate/content/ugc/${ugcId}?client_id=${clientId}`
  );
  const fetchOptions = {
    method: 'POST',
    headers: {
      'Content-type': 'application/json',
      Authorization: token,
    },

    body: JSON.stringify(body),
  };

  return fetch(fetchUrl, fetchOptions)
    .then(checkResponse)
    .then(response => response.json());
});

export type RespondServiceRequestBody = {|
  parent_ugc_id: string | number,
  subject_id: string | number,
  catalog_id: string | number,
  ugc_type: ResponseUgcType,
  text: string,
  locale: string,
|};

export const postResponse = wrapWithNetworkError(function postResponse(
  token,
  obj: RespondServiceRequestBody
): Promise<Object> {
  const fetchUrl = getEndpointUrl('/moderate/content/respond');
  const fetchOptions = {
    method: 'POST',
    headers: {
      'Content-type': 'application/json',
      Authorization: token,
    },
    body: JSON.stringify(obj),
  };

  return fetch(fetchUrl, fetchOptions)
    .then(checkResponse)
    .then(response => response.json());
});

type UpdateResponseRequest = RespondServiceRequestBody & {
  ugc_id: number,
};
export const updateResponse = wrapWithNetworkError(function(
  token: string,
  payload: UpdateResponseRequest
) {
  const fetchUrl = getEndpointUrl(`/moderate/content/${payload.ugc_id}`);
  const fetchOptions = {
    method: 'PUT',
    headers: {
      'Content-type': 'application/json',
      Authorization: token,
    },
    body: JSON.stringify(payload),
  };

  return fetch(fetchUrl, fetchOptions)
    .then(checkResponse)
    .then(response => response.json());
});

export const deleteUgc = wrapWithNetworkError(function(token: string, ugcId) {
  const fetchUrl = getEndpointUrl(`/moderate/content/${ugcId}`);
  const fetchOptions = {
    method: 'DELETE',
    headers: {
      'Content-type': 'application/json',
      Authorization: token,
    },
  };

  return fetch(fetchUrl, fetchOptions).then(checkResponse);
});

export const publicationDecision = wrapWithNetworkError(function(
  token: string,
  {
    clientId,
    ugcClientId,
    ugctype,
    observations,
  }: {
    clientId: Id,
    ugcClientId: Id,
    ugctype: UgcType,
    observations: Array<ObservationBlob>,
  }
) {
  const fetchUrl = getEndpointUrl(
    `/publication/decision?client_id=${clientId}&ugc_client_id=${ugcClientId}&ugc_type=${ugctype}`
  );
  const fetchOptions = {
    method: 'POST',
    headers: {
      'Content-type': 'application/json',
      Authorization: token,
    },
    body: JSON.stringify(observations),
  };

  return fetch(fetchUrl, fetchOptions)
    .then(checkResponse)
    .then(response => response.json());
});



// WEBPACK FOOTER //
// ./src/ducks/coreDataApi.js